import { DataTableCollapsibleRow, FormDateRangePicker, FormSelect, Heading, Loader } from "@/components"
import useReportByVendor from "./useReportByVendor";
import { Info } from "lucide-react";
import { Button, Card, CardContent, Label, Switch } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { DATE_RANGE, VENDOR } from "./consts";

const ReportByVendor = () => {
  const {breadcrumbData, title, form,
    vendorList, isLoading,
    onRunReport, onClear, isDocLoading, columns,
    subColumns,
    tableData, isRunBtnClicked, isFilterList, setIsFilterList,
    requiredFields} = useReportByVendor();
    const {errors} = form.formState;

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={title} breadcrumbData={breadcrumbData} />
      </div>

      <>
        <div className="rounded-md border-1 border-gray-300 bg-blue-100 p-3 text-[13px] flex flex-row gap-2 items-center">
          <Info className="stroke-primary" /> 
          <span>Please select one or more criteria to run the report.</span>
        </div>

        {isLoading ? <Loader /> : <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onRunReport)}>
            <Card className="my-6">
              <CardContent className="grid grid-cols-1 md:grid-cols-4 gap-[20px]">
                <FormSelect 
                  multiSelect
                  name={VENDOR}
                  placeholder="Please Select"
                  label="Vendor Name"
                  control={form.control}
                  options={vendorList?.map((data: any) => ({
                    label: `${data?.vendorName}`,
                    value: data?.vendorId?.toString()
                  }))}
                  isRequired={requiredFields.includes(VENDOR)}
                  error={errors[VENDOR]?.message}
                />
                <FormDateRangePicker 
                  name={DATE_RANGE}
                  control={form.control}
                  label="Date Range"
                  placeholder="Please select"
                  isRequired={requiredFields.includes(DATE_RANGE)}
                  error={errors[DATE_RANGE]?.message}
                />
                <div className="flex flex-row items-center gap-2 justify-end">
                  <Button variant="outline" type="button" onClick={onClear}>Clear</Button>
                  <Button>Run Report</Button>
                </div>
              </CardContent>
            </Card>
          </form>
        </FormProvider>}

        {
          isRunBtnClicked ?
          isDocLoading ? <Loader /> :
          <>
            <div className="w-full flex items-center justify-end gap-2 h-[38px] mb-5">
              <Label className="text-[14px]">All</Label>
              <Switch 
                checked={isFilterList}
                onCheckedChange={setIsFilterList}
              />
              <Label className="text-[14px]">Specific</Label>
            </div>
            <DataTableCollapsibleRow
              columns={columns}
              nestedColumns={[subColumns]}
              data={tableData || []}
              resetPageIndex
            />
          </>
          : <></>
        }
      </>
    </div>
  )
}

export default ReportByVendor;